/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type QueryLoaderHelloQueryVariables = {||};
export type QueryLoaderHelloQueryResponse = {|
  +hello: ?string
|};
export type QueryLoaderHelloQuery = {|
  variables: QueryLoaderHelloQueryVariables,
  response: QueryLoaderHelloQueryResponse,
|};
*/

/*
query QueryLoaderHelloQuery {
  hello
}
*/
const node /*: ConcreteRequest*/ = function () {
  var v0 = [{
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hello",
    "storageKey": null
  }];
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "QueryLoaderHelloQuery",
      "selections": v0 /*: any*/,
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "QueryLoaderHelloQuery",
      "selections": v0 /*: any*/
    },
    "params": {
      "cacheID": "463f9ee8a82dd6ec8dedeb28649cce74",
      "id": null,
      "metadata": {},
      "name": "QueryLoaderHelloQuery",
      "operationKind": "query",
      "text": "query QueryLoaderHelloQuery {\n  hello\n}\n"
    }
  };
}();
// prettier-ignore
node /*: any*/.hash = 'b92d001ab0208bd484a99f77c274d5ef';
module.exports = node;